import { __awaiter } from 'tslib';
import { ethers } from 'ethers';
import FortmaticClient from 'fortmatic';
import { normalizeWalletName } from '../../utils/normalizeWalletName/normalizeWalletName.js';
import { DynamicError } from '../../errors.js';
import { logger } from '../../utils/logger.js';
import { EthProviderHelper } from './ethProviderHelper.js';
import { EthProvider } from './ethProvider.js';

class Fortmatic extends EthProvider {
    constructor({ evmNetworks, apiKey, }) {
        super({ evmNetworks });
        this.name = 'Fortmatic';
        this.supportedChains = ['ETH', 'EVM'];
        this.connectedChain = 'EVM';
        this.canConnectViaQrCode = false;
        this.canConnectViaCustodialService = true;
        this.isWalletConnect = false;
        this.ethProviderHelper = new EthProviderHelper();
        this.apiKey = apiKey;
    }
    get key() {
        return normalizeWalletName(this.name);
    }
    setupEventListeners() {
        return;
    }
    teardownEventListeners() {
        return;
    }
    getFortmaticProvider() {
        const fm = new FortmaticClient(this.apiKey);
        return fm.getProvider();
    }
    getWeb3Provider() {
        const provider = new ethers.providers.Web3Provider(this.getFortmaticProvider());
        return provider;
    }
    isInstalledOnBrowser() {
        return false;
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetchPublicAddress();
        });
    }
    fetchPublicAddress() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const fmProvider = this.getFortmaticProvider();
            try {
                const [address] = yield fmProvider.enable();
                return address;
            }
            catch (error) {
                if ((error === null || error === void 0 ? void 0 : error.code) === -32603 && ((_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.includes('User denied'))) {
                    error.code = 4001; // hack the error code to be the same as Metamask
                }
                throw error;
            }
        });
    }
    signMessage(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = this.getWeb3Provider().getSigner();
            const signedMessage = yield signer.signMessage(messageToSign);
            logger.debug('signedMessage:', signedMessage);
            return signedMessage;
        });
    }
    proveOwnership(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.signMessage(messageToSign);
        });
    }
    endSession() {
        return __awaiter(this, void 0, void 0, function* () {
            const fm = new FortmaticClient(this.apiKey);
            fm.user.logout();
        });
    }
    supportsNetworkSwitching() {
        return false;
    }
    providerSwitchNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new DynamicError('Not supported');
        });
    }
}

export { Fortmatic as default };
